module.exports = __webpack_public_path__ + "static/img/zwsj.be6aaf68.png";